import _ from 'lodash';
import { isClient, isFreeProfessional, isProfessional } from '../helpers/auth';
class GoogleAnalytics {
    constructor() {
        /**
         * click event用のデータレイヤーの送信
         * @param category
         * @param label
         * @param value
         */
        this.sendClickEvent = (category, label, value) => {
            this.pushDataLayer({
                event: 'proffit-click',
                'proffit-click-category': category || '',
                'proffit-click-label': label || '',
                'proffit-click-value': value || '',
            });
        };
        /**
         * click event用のデータレイヤーの送信（data属性の値から取得）
         * @param {object} e
         */
        this.sendClickEventFromDataAtr = (e) => {
            const { dataset } = e.currentTarget;
            const { gtm_category: category, gtm_label: label, gtm_value: value, } = dataset;
            this.sendClickEvent(category, label, value);
        };
        /**
         * ログイン種別の取得
         * @param auth
         */
        this.setLoginTypeDataLayer = (auth) => {
            this.pushDataLayer({
                loginType: this.getLoginType(auth),
            });
        };
        this.setProfileDataLayer = (profile) => {
            const userType = _.get(profile, 'userType');
            if (userType === 'professional') {
                this.pushDataLayer({
                    loginId: profile.id,
                    loginUserType: _.get(profile, 'information.type'),
                });
            }
            else if (userType === 'client') {
                this.pushDataLayer({
                    experience: _.get(profile, 'information.experience'),
                    loginId: profile.id,
                    sales: _.get(profile, 'information.sales'),
                });
            }
        };
        /**
         * ログイン種別の取得
         * @param auth
         * @returns {string}
         */
        this.getLoginType = (auth) => {
            if (isProfessional(auth) || isFreeProfessional(auth)) {
                return 'professionals';
            }
            if (isClient(auth)) {
                return 'clients';
            }
            return 'guest';
        };
        this.pushDataLayer = (obj) => {
            if (!window.dataLayer) {
                window.dataLayer = [];
            }
            // 必要データの存在チェック
            if (!Array.isArray(window.dataLayer)) {
                window.dataLayer = [];
            }
            window.dataLayer.push(obj);
        };
    }
}
export default new GoogleAnalytics();
